import { faker } from '@faker-js/faker'
import { PersonalDetail } from '../../store/signup/SignupState'
import NricValidator from '../validation/personal-and-contact-details-form/NricValidator'

const signupFormGenerator = (): PersonalDetail => {
    const AGE = 80
    const nricLetter = faker.random.arrayElement([`M`, `S`, `F`, `G`])
    const nricNumber = faker.phone.phoneNumber(`#######`)
    const lastChar = (new NricValidator).generatesLastChar(nricLetter, nricNumber)

    return {
        nric: nricLetter + nricNumber + lastChar,
        name: faker.name.findName(),
        cardName: faker.name.findName(),
        dateOfBirth: faker.date.past(AGE, `2000-01-01T00:00:00.000Z`),
        mobileNumber: faker.phone.phoneNumber(`8#######`),
        email: faker.internet.email(),
        gender: faker.random.arrayElement([`M`, `F`]),
        race: {
            value: faker.random.arrayElement([`CN`, `MY`, `IN`, `EU`, `OT`]),
            code: faker.random.arrayElement([`CN`, `MY`, `IN`, `EU`, `OT`]),
        },
        residentialStatus: {
            code: faker.random.arrayElement([`SC`, `PR`]),
            value: faker.random.arrayElement([`EP`, `WP`]),
        },
        maritalStatus: {
            code: faker.random.arrayElement([`M`, `S`]),
            value: faker.random.arrayElement([`M`, `S`]),
        },
        educationalStatus: {
            code: faker.random.arrayElement([`NE`, `DP`, `OT`, `PR`, `LS`, `SE`, `NI`]),
            value: faker.random.arrayElement([`NE`, `DP`, `OT`, `PR`, `LS`, `SE`, `NI`]),
        },
        saved: false,
    }
}

export default signupFormGenerator
